








import { Component , Vue , Emit } from 'vue-property-decorator'
import { mapData} from '@/api/home'
import {getLocalItem} from '@/utils'
import axios from 'axios'
const echarts = require('echarts')
@Component({
  name: 'mapChart',
})

export default class EnergySaving extends Vue {
    private update:Boolean=true
    private chartsData :any=[]
    private myCharts :any
    private provinces:any={
        //23个省
        '台湾省': 'taiwan',
        '河北省': 'hebei',
        '山西省': 'shanxi',
        '辽宁省': 'liaoning',
        '吉林省': 'jilin',
        '黑龙江省': 'heilongjiang',
        '江苏省': 'jiangsu',
        '浙江省': 'zhejiang',
        '安徽省': 'anhui',
        '福建省': 'fujian',
        '江西省': 'jiangxi',
        '370000': 'shandong',
        '河南省': 'henan',
        '湖北省': 'hubei',
        '湖南省': 'hunan',
        '广东省': 'guangdong',
        '海南省': 'hainan',
        '四川省': 'sichuan',
        '贵州省': 'guizhou',
        '云南省': 'yunnan',
        '陕西省': 'shanxi1',
        '甘肃省': 'gansu',
        '青海省': 'qinghai',
        //5个自治区
        '新疆维吾尔自治区': 'xinjiang',
        '广西壮族自治区': 'guangxi',
        '内蒙古自治区': 'neimenggu',
        '宁夏回族自治区': 'ningxia',
        '西藏自治区': 'xizang',
        //4个直辖市
        '北京市': 'beijing',
        '天津市': 'tianjin',
        '上海市': 'shanghai',
        '重庆市': 'chongqing',
        //2个特别行政区
        '香港特别行政区': 'xianggang',
        '澳门特别行政区': 'aomen'
    }
    private oroptionmapjsonr:any={
            tooltip: {
                trigger: 'item',
            },
            series: [
            {
                type: 'map',
                zoom: 1.25,
                name:'综合能源消费量地图（万吨标准煤）',
                aspectScale: 1,
                label: {
                    normal: {
                        show: true,
                        formatter(e:any){
                            return e.name + (e.value?':' + e.value:'')
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        label: {
                        show: true,
                        color: '#fff',
                        },
                        borderType:'dashed',
                        borderWidth:1,
                        fontWeightL: 700,
                        borderColor: '#999',
                        shadowColor: '#000',
                    },
                    emphasis: {
                        label: {
                            show: true,
                            color: '#ccc',
                        },
                        borderWidth:1,
                        borderType:'dashed',
                        fontWeightL: 700,
                        areaColor: '#5b8bed',
                        borderColor: '#999',
                        shadowColor: '#000',
                    },
                },
                select:{
                    label: {
                        show: true,
                        color: '#fff',
                    },
                   itemStyle:{
                        color: '#fff',
                        areaColor:'#5b8bed'
                   }
                },
                data: this.chartsData,
            },
            ],
        }
    handleProvinceChange (value:any) {
        var _this = this
        var params = ''
        if(this.provinces.hasOwnProperty(value)){
        axios.get('https://ybpt-public.obs.cn-north-4.myhuaweicloud.com/EnergyGovMap/province/' + this.provinces[value] + '.json').then((data) => {
        echarts.registerMap(value, data.data)
        var d = []
        for (var i = 0; i < data.data.features.length; i++) {
            d.push({
            name: data.data.features[i].properties.name,
            id: data.data.features[i].id
            })
        }
        this.renderMap(value, d)
        })
        }else{
        axios.get('https://ybpt-public.obs.cn-north-4.myhuaweicloud.com/EnergyGovMap/city/' + value + '.json').then((data) => {
            echarts.registerMap(value, data.data)
            mapData({
                regionCode:this.client.custRegionCode
            }).then(res=>{
                this.chartsData = res.data
                this.chartsData.forEach((item :any) =>{
                    item.name = item.regionName
                    item.value = item.comprehensiveEnergyConsumption?item.comprehensiveEnergyConsumption.toFixed(2):''
                })
                this.renderMap(value, this.chartsData)
            })
        })
        }

    }
    renderMap (map:any, data1:any) {
      this.oroptionmapjsonr.series = [
        {
          name: map,
          type: 'map',
          mapType: map,
          roam: false,
          nameMap: {
            'china': '中国'
          },
          label: {
            normal: {
              show: true,
              textStyle: {
                color: '#999',
                fontSize: 10
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 13
              }
            }
          },
          zoom: 1.2,
          itemStyle: {
            normal: {
              areaColor: '#c4c4c4',
              borderColor: '#808080'
            },
            emphasis: {
              areaColor: '#5b8bed'
            }
          },
          data: data1
        }
      ]
      this.oroptionmapjsonr.tooltip = {
        trigger: 'item',
        formatter(e:any){
            return e.name + (e.data.comprehensiveEnergyConsumption?':' + e.data.comprehensiveEnergyConsumption:'')
        },
      }
        const main = document.getElementById('mapChart')
        const chart1 = echarts.init(main as HTMLDivElement)
        // 渲染地图
        chart1.setOption(this.oroptionmapjsonr)
        //地图点击事件---高亮
        chart1.on('click', (param:any) => {
            if (param.data) {
                this.cllbanck(param.data)
            }
        })
    }
    @Emit('cllbanck')
    cllbanck(param:any){
        return param
    }
    nomole(e:any){
        const main = document.getElementById('mapChart')
        const chart1 = echarts.init(main as HTMLDivElement)
        this.chartsData.forEach((item:any) => {
        setTimeout(() => {
            chart1.dispatchAction({
            type: 'unselect',
            name:item.name
            })
        }, 0)
        })
    }
    private client:any =getLocalItem('client')
    created() {
        this.handleProvinceChange(this.client.custRegionCode)
    }
}
